import React, { useState, useEffect, memo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Big from 'big.js';
import Text from 'components/shared/Text';
import { compareComplexProps } from 'helpers/memo';
import Headers from './Headers';
import Spread from './Spread';
import Side from './Side';
import styles from './styles.module.scss';
import sharedStyles from '../styles.module.scss';

Big.RM = 0;

function OrderBook({ orderBook, market, onClickOrder }) {
  const [enableAnimation, setEnableAnimation] = useState(false);

  const { t } = useTranslation();
  const { buys, sells, spread } = orderBook;

  useEffect(() => {
    return () => {
      if ((buys?.length > 0 || sells?.length > 0) && !enableAnimation) {
        setEnableAnimation(true);
      }
    };
  }, [buys, sells, enableAnimation]);

  return (
    <table
      role="grid"
      aria-label="order-book"
      className={classnames(sharedStyles.table, { [styles.enabledAnimation]: enableAnimation })}>
      <Headers />
      {!sells || sells.length === 0 ? (
        <tbody className={styles.noLiquidity}>
          <tr>
            <td>
              <Text muted styles={[styles.noLiquidityText]}>
                {t('market_no_sell_liq')}
              </Text>
            </td>
          </tr>
        </tbody>
      ) : (
        <Side
          market={market}
          data={sells}
          maxQty={orderBook.maxSellAmount}
          side="sells"
          onClickOrder={onClickOrder}
        />
      )}
      <Spread market={market} spread={spread} />
      {!buys || buys.length === 0 ? (
        <tbody className={styles.noLiquidity}>
          <tr>
            <td>
              <Text muted styles={[styles.noLiquidityText]}>
                {t('market_no_buy_liq')}
              </Text>
            </td>
          </tr>
        </tbody>
      ) : (
        <Side
          market={market}
          data={buys}
          maxQty={orderBook.maxBuyAmount}
          side="buys"
          onClickOrder={onClickOrder}
        />
      )}
    </table>
  );
}

OrderBook.propTypes = {
  orderBook: PropTypes.object.isRequired,
  market: PropTypes.object,
  onClickOrder: PropTypes.func.isRequired
};

OrderBook.defaultProps = {
  market: undefined
};

export default memo(OrderBook, compareComplexProps);
